// extracted by mini-css-extract-plugin
export default {"contacts":"Contacts_contacts__OGw8D","imageBox":"Contacts_imageBox__isNcZ","button":"Contacts_button__k1v2i"};